<template>

  <v-tabs-items class="note-preview-tab-items"
                v-model="activeNoteTab">
    <v-tab-item v-for="(item, i) in items"
                :key="i">
      <v-card>
        <v-card-text>{{ item.content }}</v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs-items>

</template>

<script>
  export default {
    name: "NotePreview",
    props: ['activeNoteTab'],
    data () {
      return {
        items: [
          { content: 'Recent note' },
          { content: 'Pinned note' }
        ],
      }
    }
  }
</script>

<style lang="scss" scoped>

  .v-card {
    box-shadow: none;
  }

  .v-card__text {
    padding: 0;
  }

</style>
